import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { connect } from 'react-redux'

import Loader from './Loader'

const List = ({ mainID, category, labels, data, loading, history, user, filter: { fieldFilter, valueFilter } }) => {
  const _handleRowClick = (id) => {
    history.push(`/${category}/${id}`)
  }
  // const _handleCsvClick = (id, e) => {
  //   e.stopPropagation()
  //   switch (category) {
  //     case 'owners':
  //       console.log('downloading csv from id: ', id)
  //       break
  //     case 'properties':
  //       console.log('downloading csv from id: ', id)
  //       break
  //     default:
  //       break
  //   }
  // }

  const _handlePushClick = (data, e) => {
    e.stopPropagation()
    switch (category) {
      case 'owners':
        history.push(`/push/add/owner/${data[mainID]}`)
        break
      case 'properties':
        history.push(`/push/add/property/${data.bits_property_id}`)
        break
      case 'residents':
        history.push(`/push/add/resident/${data[mainID]}`)
        break
      default:
        break
    }
  }

  const _handleChatClick = (id, e) => {
    e.stopPropagation()
    switch (category) {
      case 'owners':
        history.push(`/chat/owner/${id}`)
        // history.push(`/chat/${id}`)
        break
      case 'properties':
        history.push(`/chat/property/${id}`)
        // history.push(`/chat/${id}`)
        break
      case 'residents':
        history.push(`/chat/resident/${id}`)
        // history.push(`/chat/${id}`)
        break
      default:
        break
    }
  }

  const _renderLabels = () => {
    if (!user || user.user_role === null) {
      return null
    }
    return labels.map(label => {
      if (
        Number(user.user_role) === 2 &&
        (
          label.id === 'chat' ||
          label.id === 'push' ||
          label.id === 'csv_url'
        )
      ) {
        return null
      }
      return <th key={label.name} className="small">{ label.name }</th>
    })
  }

  const _renderRows = () => {
    if (data.length > 0) {
      let filteredData
      if (!fieldFilter || !valueFilter) {
        filteredData = data
      } else {
        filteredData = _.filter(data, (item) => {
          return String(item[fieldFilter]).toLowerCase().indexOf(String(valueFilter).toLowerCase()) > -1
        })
      }
      // console.log('filter: ', fieldFilter, valueFilter)
      // console.log('filtered data: ', filteredData)
      return filteredData.map((item) => {
        // console.log('item: ', item)
        // console.log('item id: ', item[mainID])
        const itemID = item[mainID]
        // console.log('category: ', category, 'id: ', itemID)
        if (itemID) {
          return (
            <tr key={`${category}_${itemID}`} onClick={ () => _handleRowClick(itemID)}>
              { _renderCells(item) }
            </tr>
          )
        }
        return null
      })
    }
    return null
  }

  const _renderCells = (data) => {
    // console.log('data: ', data)
    return labels.map(label => {
      // console.log('label: ', label)
      switch (label.id) {
        case 'csv_url':
          if (Number(user.user_role) === 2) {
            return null
          }
          return (
            <td key={`csv_${data[mainID]}`} className="text-center">
              <a
                className="btn csv_btn download_btn"
                href={`http://${data[label.id]}` || '#'}
                target="_blank"
                onClick={ (e) => { e.stopPropagation() } }
              >
                <svg viewBox="0 0 24 24" className="icon_download">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line x1="12" y1="15" x2="12" y2="3"></line>
                </svg>
                <span>CSV</span>
              </a>
            </td>
          )
        case 'push':
          if (Number(user.user_role) === 2) {
            return null
          }
          let pushTitle = ''
          switch (category) {
            case 'owners':
              pushTitle = 'この管理会社・オーナーの物件にお住まいの全ての入居者のプッシュ通知画面に移動します'
              break
            case 'properties':
              pushTitle = 'この物件にお住まいの全ての入居者のプッシュ通知画面に移動します'
              break
            case 'residents':
              pushTitle = 'この入居者のプッシュ通知画面に移動します'
              break
            default:
              break
          }
          return (
            <td key={`push_${data[mainID]}`}>
              <button
                className="btn chat_btn"
                onClick={(e) => { _handlePushClick(data, e) }}
                title={pushTitle}
              >
                <svg viewBox="0 0 24 24" className="icon_chat">
                  <path d="M22 17H2a3 3 0 0 0 3-3V9a7 7 0 0 1 14 0v5a3 3 0 0 0 3 3zm-8.27 4a2 2 0 0 1-3.46 0"></path>
                </svg>
                <span>通知へ</span>
              </button>
            </td>
          )
        case 'chat':
          if (Number(user.user_role) === 2) {
            return null
          }
          let chatTitle = ''
          switch (category) {
            case 'owners':
              chatTitle = 'この管理会社・オーナーの物件にお住まいの全ての入居者のチャット画面に移動します'
              break
            case 'properties':
              chatTitle = 'この物件にお住まいの全ての入居者のチャット画面に移動します'
              break
            case 'residents':
              chatTitle = 'この入居者のチャット画面に移動します'
              break
            default:
              break
          }
          return (
            <td key={`chat_${data[mainID]}`}>
              <button
                className="btn chat_btn"
                onClick={(e) => { _handleChatClick(data[mainID], e) }}
                title={chatTitle}
              >
                <svg viewBox="0 0 24 24" className="icon_chat">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
                <span>チャットへ</span>
              </button>
            </td>
          )
        default:
          return <td key={`${label.id}_${data[mainID]}`}>{ data[label.id] }</td>
      }
    })
  }

  const _renderLoader = () => {
    return loading ? <Loader key="loader" classname="loader_dot_circle"/> : null
  }

  return ([
    <table className="list" key="list">
      <thead>
        <tr>
          { _renderLabels() }
        </tr>
      </thead>
      <tbody>
        { _renderRows() }
      </tbody>
    </table>,
    _renderLoader()
  ])
}

List.propTypes = {
  mainID: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired
}

List.defaultProps = {
  loading: false
}

function mapStateToProps ({ user, filter }) {
  return { user, filter }
}

export default withRouter(connect(mapStateToProps, null)(List))



// WEBPACK FOOTER //
// ./src/components/_common/List.js